import { BULL_TINT, BEAR_TINT } from "./format";
import ActionBadge from "./ActionBadge";

type LegRowProps = {
  side: string; // "Buy" / "Sell" — colours the chip and the row tint
  contract: string; // bold, e.g. "$490 Call"
  expiry?: string;
  type?: string;
  quantity?: string;
  premium?: string; // pre-formatted per-share, e.g. "$2.35"
};

/** One leg of a multi-leg spread, tinted by its side (buy = green, sell = red). */
const LegRow = ({ side, contract, expiry, type, quantity, premium }: LegRowProps) => (
  <div
    className={`flex items-center gap-3 rounded-lg px-3 py-2.5 ${
      /sell/i.test(side) ? BEAR_TINT : BULL_TINT
    }`}
  >
    <ActionBadge verb={side} />
    <span className="text-sm font-bold text-token-text-primary">{contract}</span>
    {expiry && <span className="text-xs text-token-text-secondary">{expiry}</span>}
    {type && <span className="text-xs uppercase tracking-wide text-token-text-secondary">{type}</span>}
    <span className="ml-auto flex items-center gap-3">
      {quantity && <span className="text-xs text-token-text-secondary">{quantity}</span>}
      {premium && <span className="text-sm font-bold text-token-text-primary">{premium}</span>}
    </span>
  </div>
);

export default LegRow;
